import { LiliPasswordInput } from '@lili/lili-frontend-common';
import { Controller } from 'react-hook-form';
import { OnboardingFormFields } from '@Types/index.ts';
import i18next from '@in18/in18';

const { t } = i18next;

interface PasswordInputProps {
  disabled?: boolean;
  tabIndex?: number;
  fieldName?: OnboardingFormFields;
  title?: string;
  hideHints?: boolean;
}

export const PasswordInput = ({ disabled, tabIndex, hideHints }: PasswordInputProps) => {
  return (
    <Controller
      name={OnboardingFormFields.PASSWORD}
      render={({ field: { onBlur, onChange } }) => (
        <LiliPasswordInput
          onChange={onChange}
          id={OnboardingFormFields.PASSWORD}
          title={t('pages.home.password')}
          onBlur={onBlur}
          {...(hideHints
            ? {}
            : {
                passwordValidationTexts: {
                  lengthRequirement: t('validation.lengthRequirement'),
                  uppercaseRequirement: t('validation.uppercaseRequirement'),
                  lowercaseRequirement: t('validation.lowercaseRequirement'),
                  numberRequirement: t('validation.numberRequirement'),
                },
              })}
          tabIndex={tabIndex}
          disabled={disabled}
        />
      )}
    />
  );
};

export const PasswordInputWithoutHints = ({
  disabled,
  tabIndex,
  fieldName,
  title,
}: PasswordInputProps) => {
  return (
    <Controller
      name={fieldName || OnboardingFormFields.PASSWORD}
      render={({ field: { onBlur, onChange } }) => (
        <LiliPasswordInput
          initialValue=''
          onChange={onChange}
          id={fieldName || OnboardingFormFields.PASSWORD}
          title={title || t('pages.home.password')}
          onBlur={onBlur}
          tabIndex={tabIndex}
          disabled={disabled}
        />
      )}
    />
  );
};
